import {
  Button,
  Classes,
  Dialog,
  HTMLTable,
  Tab,
  Tabs,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import {
  IFilter,
  INfseItem,
  IResultadoItem,
} from "../../../../model";
import { ResultadoStore } from "../../../../stores/resultados/ResultadoStore";
import * as moment from "moment";
import { AppStore } from "../../../../stores/AppStore";
import { copyToClipboard, formatCnpj } from "../../../../utils";
import { toast } from "react-toastify";
import { api } from "../../../../api";
import { ItemMemoria } from "./ItemMemoria";
const numeral = require("numeral");

interface NfseItemDialogProps {
  item: IResultadoItem;
  modelo: string;
  entrada_saida: string;
  data: any;
  onClose: () => void;
}

interface NfseItemDialogState { }

@observer
export class NfseItemDialog extends React.Component<
  NfseItemDialogProps,
  NfseItemDialogState
> {

  obs = observable({
    item: {} as INfseItem,
    filtro: {} as IFilter,
    dhemi: null as string
  })

  async componentDidMount() {
    let data = {
      tipo: this.props.entrada_saida.toLowerCase(),
      id: this.props.item._id,
      modelo: this.props.modelo,
    };

    this.obs.filtro = {
      tipo: this.props.modelo,
      filtro: this.props.entrada_saida,
      empresa: AppStore.obs1.selectedEmpresa,
      data1: moment(this.props.data[0]).format("YYYY-MM-DD"),
      data2: moment(this.props.data[1]).format("YYYY-MM-DD"),
      ids: [""],
    };

    try {
      let resp = await api.post(`/api/notas/nfse/item`, data);
      this.obs.item = resp.data;
      this.obs.dhemi = resp.data.dhemi;

      if(resp.data.calc_id) await ResultadoStore.loadDetalhamentoCalculo(resp.data.calc_id)

    } catch (ex) { }
  }

  renderNoData() {
    return (
      <div>
        Aguarde... &nbsp; &nbsp; &nbsp;

        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  handleViewXML = async (chave: string, entrada_saida: string, modelo: string, dhemi: string) => {

    await ResultadoStore.download_xml(chave, entrada_saida, modelo, dhemi, AppStore.obs1.selectedEmpresa?.cnpj);

  };

  handleCopyChave = () => {
    copyToClipboard(this.obs.item.nota?.chave);
    toast.success("Chave de acesso copiada", {});
  };

  handleCopyId = () => {
    copyToClipboard(this.obs.item?.contestacao_id);
    toast.success("Id Contestação copiado", {});
  };

  handleViewPDF = async () => {

    var ids = {
      ids: [{cancelada: false, chave: this.obs.item.chave}],
      filtro: this.props.entrada_saida,
      tipo: this.props.modelo,
      empresa: AppStore.obs1.selectedEmpresa.cnpj,
      data1: moment(this.obs.item.dhemi).format("YYYY-MM-DD"),
      data2: moment(this.obs.item.dhemi).format("YYYY-MM-DD"),
    };

    await ResultadoStore.view_danfe(ids, this.obs.item.chave, AppStore.obs1.selectedEmpresa);

  };

  renderDetailsTab() {
    return (
      <div>
        <HTMLTable
          className="table table-hover dataTable"
          style={{ width: "100%" }}
        >
          <tbody>
            <tr>
              <td>Descrição</td>
              <td>{this.obs.item.descricao}</td>
            </tr>
            <tr>
              <td>Tributação</td>
              <td style={{ textAlign: "right" }}>
                {this.obs.item.forma_tributacao}
              </td>
            </tr>
            <tr>
              <td>ISSQN</td>
              <td style={{ textAlign: "right" }}>
                {numeral(this.obs.item.issqn).format("$ 0,0.00")}
              </td>
            </tr>
            <tr>
              <td>Chave</td>
              <td style={{ textAlign: "right" }}>
                {this.obs.item.chave}
              </td>
            </tr>
            <tr>
              <td>Valor do item</td>
              <td style={{ textAlign: "right" }}>
                {numeral(this.obs.item.valor).format("$ 0,0.00")}
              </td>
            </tr>
            <tr>
              <td>Prestador</td>
              <td style={{ textAlign: "right" }}>
                {this.obs.item.prestador ? formatCnpj(this.obs.item.prestador) : ""}
              </td>
            </tr>
            <tr>
              <td>Tomador</td>
              <td style={{ textAlign: "right" }}>
                {this.obs.item.tomador ? formatCnpj(this.obs.item.tomador) : ""}
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: "middle" }}>ID Contestação</td>
              <td style={{ verticalAlign: "middle" }}>
                <span style={{ marginRight: 10 }}>{this.obs.item?.contestacao_id}</span>
                <Button
                  small
                  minimal
                  icon="clipboard"
                  onClick={this.handleCopyId}
                />
              </td>
            </tr>
          </tbody>
        </HTMLTable>
        <Button
          text="Download XML"
          className="DownloadXML"
          onClick={(e) =>
            this.handleViewXML(
              this.obs.item.chave,
              this.props.entrada_saida,
              this.props.modelo,
              this.obs.dhemi
            )
          }
        />

        <Button
          text="Download PDF"
          className="DownloadXML"
          style={{ marginRight: 10 }}
          onClick={(e) => this.handleViewPDF()}
        />

      </div>
    );
  }

  renderMemoriaCalc(memoria_calculo: string) {
    let calcName: any = this.obs.item.calc ? this.obs.item.calc : "Nenhum";

    return (
      <ItemMemoria
        memoria_calculo={memoria_calculo}
        calcName={calcName}
        calc_vars={ResultadoStore.obs.calc_vars}
        nota_vars={ResultadoStore.obs.nota_vars}
        descritivo={ResultadoStore.obs.descritivo_calc}
      />
    );
  }

  renderData() {
    return (
      <Tabs id="tabs" className="tabsCalculos">
        <Tab id="details" title="Detalhes" panel={this.renderDetailsTab()} />
        {this.obs.item.memoria_calculo ?
          <Tab
            id="calc"
            title="Memória de cálculo ICMS"
            panel={this.renderMemoriaCalc(this.obs.item.memoria_calculo)}
          />
          : <></>}
        {this.obs.item.memoria_calculo_1139 ?
          <Tab
            id="calc_1139"
            title="Memória de cálculo ICMS 1139"
            panel={this.renderMemoriaCalc(this.obs.item.memoria_calculo_1139)}
          />
          : <></>}
      </Tabs>
    );
  }

  render() {
    let title = "Detalhes";
    if (this.obs.item) {
      title = `Detalhes: ${this.obs.item.nnfe}`;
    }

    return (
      <Dialog
        isOpen={true}
        title={title}
        onClose={this.props.onClose}
        style={{ width: 650, height: 600 }}
      >
        <div className={Classes.DIALOG_BODY}>
          {(this.obs.item && this.renderData()) || this.renderNoData()}
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" onClick={this.props.onClose} />
          </div>
        </div>
      </Dialog>
    );
  }
}
